(() => {
  const drawer = document.getElementById('CartDrawer');
  if (!drawer) return;
  let observer;
  const load = () => {
    const template = drawer.querySelector('template[data-gtfo-drawer-wallets]');
    if (!template) return;
    template.replaceWith(template.content.cloneNode(true));
    drawer.dataset.gtfoWallets = 'loaded';
    observer?.disconnect();
  };
  const onOpen = () => {
    if (drawer.classList.contains('drawer--is-open')) load();
  };
  observer = new MutationObserver(onOpen);
  observer.observe(drawer, {attributes:true, attributeFilter:['class']});
  document.addEventListener('cart:open', load, {once:true});
  onOpen();
})();
